import { FC, useContext } from "react";

import Dialog from "@mui/material/Dialog";

import { NewProcedureForm } from "@/components/Procedures/NewProcedure/NewProcedureForm";

import { UserContext } from "@/model/User/UserContext";

export interface NewProcedureProps {
  open: boolean;
  onClose: () => void;
}

export const NewProcedureModal: FC<NewProcedureProps> = (props) => {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  const user = useContext(UserContext);

  return (
    <Dialog onClose={handleClose} open={open} fullWidth>
      <NewProcedureForm user={user} handleClose={handleClose} open={open} />
    </Dialog>
  );
};
